'use strict';
var ENVIRONMENT = require('../internals/environment');

module.exports = ENVIRONMENT === 'NODE';



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-sync/node_modules/core-js/internals/environment-is-node.js
// module id = 1597
// module chunks = 25